export const INFO_SCREEN = "/info";
export const LOGIN_SCREEN = "/";
export const FORGOT_PASSWORD_SCREEN = "/forgot-password";
export const DASHBOARD_SCREEN = "/dashboard";
export const DASHBOARD_MAP = "/dashboard/map";
export const DASHBOARD_BIKES = "/dashboard/bikes";
export const DASHBOARD_LOCKS = "/dashboard/locks";
export const DASHBOARD_BIKE = "/dashboard/bike/:id";
export const DASHBOARD_STATIONS = "/dashboard/stations";
export const DASHBOARD_DOCKS = "/dashboard/docks";
export const DASHBOARD_RENTALS = "/dashboard/rentals";
export const DASHBOARD_RENTALS_GALLERY = "/dashboard/rentals/gallery";
export const DASHBOARD_RENTAL_RULES = "/dashboard/rental-rules";
export const DASHBOARD_TRANSACTIONS = "/dashboard/transactions";
export const DASHBOARD_TRANSACTION = "/dashboard/transaction/:id";
export const DASHBOARD_CITIES = "/dashboard/cities";
export const DASHBOARD_USERS = "/dashboard/users";
export const CUSTOMER_RESTRICTIONS_ROUTE = "/dashboard/customer-restrictions";
export const DASHBOARD_USER = "/dashboard/user/:id/:cityId?";
export const BIKES_HISTORY = "/history/:id";
export const BIKE_HISTORY = "/dashboard/bike/history";
export const USER_LEDGER = "/dashboard/ledger/:id/:cityId";
export const DASHBOARD_CUSTOMER = "/dashboard/customer/:id/:cityId";
export const COUPONS_ROUTE = "/dashboard/coupons";
export const USER_MANAGEMENT_ROUTE = "/dashboard/user-management";
export const SERVICE_ACCOUNTS_ROUTE = "/dashboard/service-accounts";
export const REFERRAL_ROUTE = "/dashboard/referral";
export const SETTINGS_ROUTE = "/dashboard/settings";
export const NOTIFICATIONS_ROUTE = "/dashboard/notifications";
export const BOOKING_ROUTE = "/dashboard/booking";
export const MFA_ROUTE = "/dashboard/mfa";
// The canonical pricing hub. Ride pricing and ride passes are one concept for
// an operator, so they share one entry point; the tab lives in the query string
// so a bookmark or a browser Back lands on the tab it was taken from.
export const PRICING_HUB_ROUTE = "/dashboard/pricing";
export const PRICING_PLAN_EDITOR_ROUTE = "/dashboard/pricing-plan-editor/:id";
export const PRICING_PLAN_EDITOR_CREATE_ROUTE =
  "/dashboard/pricing-plan-editor/";
export const PRICING_PLAN_DOMAINS_ROUTE = "/dashboard/pricing-plan-domains/:id";
export const USER_COUPON_ROUTE = "/dashboard/coupon-user/:id";
export const INTROS_ROUTE = "/dashboard/cities/:code/intros";
export const WARNINGS_ROUTE = "/dashboard/cities/:code/warnings";

export const ASSET_PROJECTS = "/dashboard/asset/projects";
export const ASSET_ASSETS = "/dashboard/asset/assets";
export const ASSET_BOOKINGS = "/dashboard/asset/bookings";

export const DASHBOARD_RESERVATIONS = "/dashboard/reservations";
export const DASHBOARD_ANALYTICS = "/dashboard/analytics";
export const DASHBOARD_ANALYTICS_V2 = "/dashboard/analytics-v2";
export const DASHBOARD_CHAT_ANALYTICS = "/dashboard/chat-analytics";

// V2 UI Route
export const V2_DASHBOARD_SCREEN = "/v2/dashboard";

// Helper to convert routes to V2 versions
export const toV2Route = (route) => "/v2" + route;

export const PROMOTIONS_ROUTE = "/dashboard/promotions";
export const PROMOTIONS_COUPONS_ROUTE = "/dashboard/promotions/coupons";
export const PROMOTIONS_REFERRALS_ROUTE = "/dashboard/promotions/referrals";
export const PROMOTIONS_REWARDS_ROUTE = "/dashboard/promotions/rewards";
export const PROMOTIONS_CLAIMS_ROUTE = "/dashboard/promotions/claims";
export const PROMOTIONS_TOPUP_BONUSES_ROUTE =
  "/dashboard/promotions/topup-bonuses";

export const APP_VERSIONS_ROUTE = "/dashboard/app-versions";
export const SERVICE_HEALTH_ROUTE = "/dashboard/service-health";
export const API_DOCS_ROUTE = "/dashboard/api-docs";
export const FEATURE_FLAGS_ROUTE = "/dashboard/feature-flags";
export const PROMOTIONS_RIDE_PASSES_ROUTE = "/dashboard/promotions/ride-passes";
export const APP_CONFIGURATION_ROUTE = "/dashboard/app-configuration";
export const DASHBOARD_ORGANIZATIONS = "/dashboard/organizations";
export const DASHBOARD_PARTNERS = "/dashboard/partners";
export const DASHBOARD_PARTNER_DETAIL = "/dashboard/partners/:id";
export const DASHBOARD_FINES = "/dashboard/fines";
export const DASHBOARD_FINE_DETAIL = "/dashboard/fines/:fineId";
export const DASHBOARD_VEHICLE_MODELS = "/dashboard/vehicle-models";
export const DASHBOARD_VEHICLE_MODEL_DETAIL = "/dashboard/vehicle-models/:id";

// Standalone unauthenticated route for partner magic-link dashboards.
// Lives outside the admin app shell — no sidebar, no Firebase auth.
export const PARTNER_VIEW_ROUTE = "/partner-view";
